module.exports = __webpack_public_path__ + "img/8e2ea2a.jpg";